export default "__VITE_ASSET__$6_49wRd__"